export enum EventType {
	CLOSE = 'close',
}

export const VIEventType = ['close'];

export type Event<TType extends EventType = EventType> = {
	type: TType;
};

/**
 * Interface representing a close event in the browser.
 */
export interface CloseEvent extends Event<EventType.CLOSE> {
	/**
	 * The reason for the browser being closed.
	 */
	reason: CloseReason;
}

export enum CloseReason {
	API = 'API',
	USER = 'USER',
	TIMEOUT = 'TIMEOUT',
}
